<template>
  <v-card flat>
    <v-row no-gutters class="py-0 px-2 pt-0 mt-0">
      <v-col cols="12" class="pt-0 mt-0">
        <v-row class="">
          <v-col cols="12">
            <v-text-field
              v-model="streamUrl"
              readonly
              :hide-details="true"
              dense
              outlined
              :label="$t('message.pages.newLive.streamUrl')"
              :disabled="liveStatus === 'deleted'"
              compact
            >
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      @click="handleShowLink(streamUrl)"
                      :disabled="liveStatus === 'deleted'"
                    >
                      mdi-content-copy
                    </v-icon>
                  </template>
                  <span>{{
                    $t('message.pages.videoEditModal.copyToClipboard')
                  }}</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="streamKey"
              readonly
              dense
              :hide-details="true"
              outlined
              :label="$t('message.pages.newLive.streamKey')"
              :disabled="liveStatus === 'deleted'"
              compact
              :type="value ? 'text' : 'password'"
            >
              <template v-slot:append>
                <v-icon
                  @click="handleDisplayKey()"
                  :disabled="liveStatus === 'deleted'"
                  class="mr-2"
                >
                  {{ value ? 'mdi-eye' : 'mdi-eye-off' }}
                </v-icon>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      @click="handleShowLink(streamKey)"
                      :disabled="liveStatus === 'deleted'"
                    >
                      mdi-content-copy
                    </v-icon>
                  </template>
                  <span>{{
                    $t('message.pages.videoEditModal.copyToClipboard')
                  }}</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        class="px-0"
        v-if="scheduled && serverStatus === 'offline' && showScheduled"
      >
        <v-alert
          outlined
          class="mt-3"
          style="width: 100%"
          :style="
            serverStatus === 'offline' &&
            liveStatus === 'offline' &&
            scheduled_at !== null &&
            timeLeft() > 30
              ? ''
              : 'margin-bottom: 0px !important;'
          "
          type="info"
          text
          border="left"
        >
          {{ $t('message.pages.newLive.liveScheduledTo') }}
          {{ scheduled.toLocaleDateString('pt-BR') }}
          {{ scheduled.toLocaleTimeString('pt-BR').slice(0, -3) }}
        </v-alert>
        <div
          style="background-color: #a0acff; border-radius: 4px"
          class="pb-2 pt-2 pl-2 pr-2 mb-4"
        >
          <div class="d-flex align-items-center">
            <v-icon class="mr-3" style="color: var(--v-brand-base)">
              mdi-information
            </v-icon>

            <p class="ma-0 mb-1 mt-1">
              <small>{{ $t('message.pages.live.scheduledWarnig') }}</small>
            </p>
          </div>
        </div>
        <v-btn
          v-if="
            serverStatus === 'offline' &&
            liveStatus === 'offline' &&
            scheduled_at !== null &&
            timeLeft() > 30
          "
          style="width: 100%"
          @click="handleInitNow"
          :loading="loadings.initNow"
          :disabled="liveStatus === 'deleted'"
          color="primary"
          outlined
          >{{ $t('message.pages.newLive.startNow') }}
        </v-btn>
        <span v-if="errors.initNow" class="red--text pt-3"
          >Erro ao iniciar live {{ errors.initNow }}</span
        >
      </v-col>

      <v-col cols="12" class="mb-0 pb-0 px-0 mt-3">
        <v-row no-gutters class="pb-2">
          <v-col cols="12">
            <v-card flat class="mt-0">
              <span class="caption">
                {{ $t('message.pages.videoEditModal.thumbnailText') }}
                <a href="https://tinypng.com/" target="_blank"
                  ><u>TinyPNG</u></a
                >
                {{ $t('message.pages.videoEditModal.thumbnailText2') }}</span
              >
            </v-card>
          </v-col>
          <v-card
            v-if="defaultThumbnail"
            class="mr-4 mt-5 d-flex align-center justify-center flex-column"
            height="90px"
            width="90px"
          >
            <img
              v-if="defaultThumbnail && !imageError"
              class="defaultThumb"
              :src="defaultThumbnail"
              @error="imageError = true"
            />
            <v-img
              v-else
              max-width="50"
              max-height="50"
              src="@/assets/pandaHappy.svg"
            ></v-img>
          </v-card>
          <v-card
            v-if="hasEditVideoPerm"
            class="d-flex flex-column justify-center align-center mr-3 mt-5"
            height="90px"
            width="90px"
          >
            <v-file-input
              v-model="newThumbnail.file"
              v-if="!loadings.newThumbnail"
              height="20px"
              class="d-flex align-center justify-center ma-0 pa-0 pl-2"
              hide-input
              prepend-icon="mdi-upload"
              accept="image/png, image/jpeg"
              @change="handleChangeThumbnail"
              :disabled="liveStatus === 'deleted'"
            ></v-file-input>
            <v-progress-circular
              v-else
              :size="22"
              width="3"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-card>
        </v-row>
        <v-card flat height="45">
          <span
            v-if="errors.addThumbnail || errors.wrongThumbnailFile"
            class="red--text caption align-text"
          >
            <v-icon color="red" size="16" class="pb-1 pr-1">
              mdi-alert-circle
            </v-icon>
          </span>
          <div v-if="successfulChangedThumb" class="d-flex align-start mt-1">
            <v-icon color="primary" class="mr-1">mdi-check</v-icon>
            <span
              class="black--text caption align-text"
              v-html="$t('message.pages.videoEditModal.serverUpdateOnUpload')"
            />
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import i18n from '@/translations/lang'
import { THUMB_URL } from '@/config/envs'

export default {
  name: 'VideoLive',
  props: [
    'liveStatus',
    'viewers',
    'scheduled',
    'liveInfo',
    'serverStatus',
    'showScheduled',
    'timeLeft',
    'scheduled_at',
    'handleInitNow',
    'loadings',
    'errors',
    'defaultThumbnail',
    'imageError',
    'newThumbnail',
    'handleChangeThumbnail',
    'successfulChangedThumb',
  ],
  data: () => ({
    streamUrl: '',
    streamHls: '',
    streamKey: '',
    value: false,
    showLiveTitle: false,
    showCDN: false,
  }),
  computed: {
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
  },
  async mounted() {
    this.streamUrl = this.$root.streamUrl
    this.streamHls = this.$root.streamHls
    this.streamKey = this.$root.streamKey
    this.loadDefaultThumbnail()
  },
  watch: {
    defaultThumbnail(val) {
      if (!val || val.indexOf('date') === -1) {
        this.loadDefaultThumbnail()
      }
    },
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    handleDisplayKey() {
      this.value = !this.value
    },
    handleShowLiveTitle() {
      this.$root.$emit('changeShowLiveTitle', this.showLiveTitle)
    },
    handleShowLink(item) {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.copiedToClipboard'),
      })
      navigator.clipboard.writeText(`${item}`)
    },
    loadDefaultThumbnail() {
      if (this.liveInfo.config.thumbnail) {
        let LIBRARY_ID = this.liveInfo.live_player
          .split('//')
          .pop()
          .split('.')[0]
          .replace('player-', '')

        this.defaultThumbnail = `${THUMB_URL}/${LIBRARY_ID}/${
          this.liveInfo.config.thumbnail
        }?date=${new Date().getTime()}`
      }
    },
  },
}
</script>

<style scoped></style>
